module.exports = __webpack_public_path__ + "static/media/3DPPA19.3d7e7bee.jpg";